import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const SPEND_LIMIT_PERIODS_KEY = 'SPEND_LIMIT_PERIODS';

const useGetSpendLimitPeriodsQuery = (id?: string) => {
  const { isLoading, isError, isSuccess, data } = useQuery(
    [SPEND_LIMIT_PERIODS_KEY, id],
    () => api.get(API_URL.SPEND_LIMIT_PERIODS_BY_ACCOUNT_ID(id || '')),
    {
      enabled: !!id,
    }
  );

  return {
    data: data?.data,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useGetSpendLimitPeriodsQuery;
